import { DatePicker } from '@liveauctioneers/hammer-ui-core/datePicker';
import { useIntl } from '@liveauctioneers/hammer-ui-core/intl';
import { parseISO } from 'date-fns';
import * as React from 'react';
import isEqual from 'react-fast-compare';

import { Facet } from './Facet';

type Props = {
    onDateChange: Function;
    selectedDate: string;
};

const DatePickerFacet = ({ onDateChange, selectedDate }: Props) => {
    const { formatMessage } = useIntl();
    const date = selectedDate !== '' ? parseISO(selectedDate) : undefined;

    return (
        <Facet
            className="date-picker-facet auction-date"
            closeFacet={false}
            title={formatMessage({ id: 'auction_date' })}
        >
            <DatePicker
                closeOnSelect
                date={date}
                onClear={() => {
                    onDateChange('');
                }}
                onValidDateChange={(dateChanged) => {
                    onDateChange(dateChanged);
                }}
                placeholder={formatMessage({ id: 'select_date_placeholder' })}
                showClearIcon
            />
        </Facet>
    );
};

export default React.memo<Props>(DatePickerFacet, isEqual);
